import React, { ReactElement } from "react";

import classNames from "classnames";

import {
  chatHistoryPanelCSS,
  chatHistoryPanelInDialogCSS,
} from "./ChatHistoryPanel.styles";
import { ChatHistoryPanelProps } from "./ChatHistoryPanel.types";

export const ChatHistoryPanel = ({
  children,
  className,
  isFullScreen,
  openHistoryPanel,
  ...rest
}: ChatHistoryPanelProps): ReactElement => {
  return (
    <div
      className={classNames(
        chatHistoryPanelCSS,
        {
          [chatHistoryPanelInDialogCSS]: !isFullScreen,
          open: openHistoryPanel,
        },
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
